export default __webpack_public_path__ + "static/media/logo_mojitok_stickerfarm_gray.9d3d7ecb.svg";